import $ from 'jquery';
import calcImgSize from './calc_image_size';
import setImageStyle from './set_image_style';
import handleLastLine from './handle_last_line';
import getDefaultLineState from './get_line_state';

function ImageCalculator(defaultConfig) {
  const DEFAULT_DIV_WIDTH = defaultConfig.fixedImageDivWidth + defaultConfig.imageDivMargin;

  /**
   * getAddImageWidth
   * 1줄당 이미지 커팅을 위해서 로직체크를 할때, 해당 이미지가 fix사이즈로 div고정이 될지
   * 아니면 기본적인 영역계산으로 될지 반환하는 메소드,
   * 해당 부분이 mathImageDiv에 비슷하게 존재하지만,
   * 계산전에 커팅하는 단계에서도 알아야 하기 때문에 메소드로 따로 만듬.
   * @param tmp_img_data imgDataObject
   * @returns int
   */
  function getAddImageWidth(tmp_img_data) {
    if (typeof(tmp_img_data) === "undefined") {
      return 0;
    }
    return (tmp_img_data.w >= defaultConfig.fixedImageDivWidth) ? tmp_img_data.w : (defaultConfig.fixedImageDivWidth + defaultConfig.imageDivMargin);
  }

  function setImageSizeToData(appState, boardState, imageDataItems) {
    const boardWidth = boardState.boardWidth;
    const maxBodyWidthOverflow = boardWidth + Math.floor(boardWidth * defaultConfig.boardOverflowLimit);
    const state = {
      boardWidth,
      maxBodyWidthOverflow,
      lastIndex: 0,
      lineCount: 0,
      isSingleLine: true,
      dataSize: imageDataItems.length
    };

    // 매번 계산시 마지막 라인에 들어가는 이미지인지 확인하기위해 마커 추가
    $.each(imageDataItems, (idx, each) => {
      each.isInLastLine = true;
    });
    countImagesForEachLine(state, imageDataItems, (imagesInLine, state, lineState) => {
      $.each(imagesInLine, (idx, eachImageData) => {
        // 이 콜백 라인에는 하나의 라인을 이루는 각각의 아이템들이 들어오는데,
        // 마지막 라인에 있는 이미지는 이 콜백에 들어오지 못한다
        // handleLastLine에서 isInLastLine === true인 아이템을 잡아오기 위해 사용한다
        eachImageData.isInLastLine = false;
      });
      calculateImageDivSize(imagesInLine, state, lineState);
    });

    // 꽉 채워지지 않은 마지막 라인의 이미지에 대한 처리
    // 콜백은 초기화면시 이미지 수가 너무 적어 모두 노출해야 하는 케이스일때 실행된다
    handleLastLine(appState, state, imageDataItems, (lastLine, state, lastLineState) => {
      const lastLineStateParam = $.extend({}, lastLineState, {
        gap: lastLineState.accImageWidth - state.boardWidth
      });
      state.lastIndex = state.lastIndex + lastLine.length;
      calculateImageDivSize(lastLine, state, lastLineStateParam);
    }, defaultConfig);

    function calculateImageDivSize(imagesInLine, state, lineState) {
      calcImgSize(defaultConfig)(imagesInLine, state, lineState, (calcState, eachImageData) => {
        setImageStyle(defaultConfig)(calcState, eachImageData);
        lineState.accDivWidth += eachImageData.dw;
        eachImageData.vTarget = state.lastIndex;
        adjustLastImageOfEachLine(eachImageData, state, lineState, calcState);
      });
    }
  }


  function adjustLastImageOfEachLine(data, state, lineState) {
    if (data.index !== lineState.lastIdx) {
      return;
    }

    // 일단 라인당 남는 오차에 대한 보정은 맨 마지막이 fix type인 경우에만 하도록 둔다.
    // flag_single_line == true 일땐 하지 않는다.
    if (data.fixed && state.isSingleLine) {
      //라인당 남는 오차
      const misCalc = lineState.accDivWidth + (defaultConfig.imageDivMargin * lineState.imageCount) - state.boardWidth;
      // body가 남는 경우.
      // 처음 메소드가 호출되기 위해 한줄당 이미지 개수를 구하는 로직과 연결된다.
      // 그 로직에서 다음 이미지까지 더했을때 bodyWidth가 넘을 경우에도 로직이 실행되기 때문에, 부족한 경우에만 마지막 div의 넓이를 조정한다.
      if (misCalc < 0 && Math.abs(misCalc) > 5) {
        data.dw += Math.abs(misCalc);
      }
    }

    // 1줄에 1개 밖에 못나오는 경우.
    // 이미지를 div에 꽉차게 늘린다.
    // fixed가 아닌경우에만 한다. fixed도 늘리면 너무 모양이 이상해진다.
    if (lineState.imageStartAt === lineState.lastIdx && !state.isSingleLine && !data.fixed) {
      const zoomRatio = (data.dw - data.iw) / data.iw;
      data.dh = Math.round(data.ih + data.ih * zoomRatio);
      data.css = { width: '100%', height: '100%' };
    }
  }

  function countImagesForEachLine(state, imageDataItems, forEachLine) {
    let lineState = getDefaultLineState(state);
    let line = [];
    $.each(imageDataItems, (idx, data) => {
      const nextData = imageDataItems[idx + 1];

      setAccImageWidthByImageSize(lineState, data);
      setImageHeight(lineState, data);
      lineState.imageCount++;
      data.index = idx;
      checkSingleLine(state, nextData);
      setAccImageNext(lineState, nextData);

      line.push(data);

      onLineComplete(lineState, state, () => {
        state.lineCount++;
        state.lastIndex = idx;

        const stateParam = $.extend({}, lineState, {
          gap: lineState.accImageWidth - state.boardWidth
        });

        forEachLine(line, state, stateParam);

        line = [];
        lineState = getDefaultLineState($.extend({}, state, {
          imageStartAt: idx + 1
        }));
      });
    });

    function setAccImageWidthByImageSize(lineState, data) {
      if (data.w >= defaultConfig.fixedImageDivWidth) {
        lineState.accImageWidth += data.w;
        lineState.isWidthNormal = true;
        data.fixed = false;
      } else {
        lineState.accImageWidth += DEFAULT_DIV_WIDTH;
        lineState.isWidthFixed = true;
        data.fixed = true;
        lineState.widthFixedCount++;
      }
    }

    function setImageHeight(lineState, data) {
      const h = data.h;
      lineState.accImageHeight += h;
      if (lineState.minImageHeight > h) {
        lineState.minImageHeight = h;
      }
      if (lineState.maxImageHeight < h) {
        lineState.maxImageHeight = h;
      }
    }

    function checkSingleLine(state, nextData) {
      state.isSingleLine = getAddImageWidth(nextData) === 0 && state.lineCount === 0;
    }

    function setAccImageNext(lineState, nextData) {
      lineState.accImageWidthNext = lineState.accImageWidth + getAddImageWidth(nextData);
      lineState.accImageStepNext = (lineState.accImageWidthNext - lineState.boardWidth) / lineState.imageCount;
    }

    function onLineComplete(lineState, state, callback) {
      const isOverBoardWidth = lineState.accImageWidth >= lineState.boardWidth;
      const hasOnlyFixedWidth = lineState.isWidthFixed && !lineState.isWidthNormal;
      const hasBothImageTypes = lineState.isWidthFixed && lineState.isWidthNormal;
      const isNextWidthOverBoard = lineState.accImageWidthNext >= lineState.boardWidth;
      const isNextStepOverBoard = lineState.accImageStepNext >= defaultConfig.fixedImageDivWidth;
      const isGoingToOverflow = lineState.accImageWidthNext >= lineState.maxBodyWidthOverflow;

      const isLineComplete = isOverBoardWidth ||
        (hasOnlyFixedWidth && isNextWidthOverBoard) ||
        (hasBothImageTypes && isNextWidthOverBoard && isNextStepOverBoard) ||
        state.isSingleLine ||
        isGoingToOverflow;

      if (isLineComplete) {
        callback();
      }
    }
  }

  return setImageSizeToData;
}

export default ImageCalculator;


/** WEBPACK FOOTER **
 ** ./src/IIM/core/thumb_board/image_calculator/index.js
 **/